<template>
<div>
  <el-radio-group @change="selectDiscount" v-model="discount" size="mini">
    <el-radio-button border
                     v-for="(item, index) in discounts" :key="index"
                     :label="item.discount">{{item.name}}
    </el-radio-button>
  </el-radio-group>
</div>
</template>

<script>
  export default {
    name: 'index',
    props:['pricingId','gameId','discount'],
    data(){
      return{
        discounts:[],
      }
    },
    watch:{
      'pricingId':{
        handler(newData,oldData){
          this.getDiscount()
        }
      }
    },
    mounted(){
      this.getDiscount()
    },
    methods:{
      //获取折扣设置
      getDiscount(){
        let that=this
        that.discounts=[]
        that.discount=null
        axios.get('/api/company/discount',{params:{gameId:that.gameId,pricingType:that.pricingId}}).then(res=>{
          if(res!=null){
            console.log(res)
            that.discounts=res.data
          }
          that.discounts.unshift({name:'不打折',discount: '1'})
          that.discount='1'
        })
      },
      selectDiscount(){
        this.$emit('selectDiscount',this.discount)
      }
    }
  }
</script>

<style scoped>

</style>
